import React from 'react';
import qs from 'query-string';
import { navigate } from 'gatsby-link';

// import TwentyThreeWards from '../../_data/23-wards';
import Industries from '../../_data/industries';
import Prefectures from '../../_data/prefectures';
import Salary from '../../_data/salary';
import searchIcon from '../../_assets/images/search-icon.png';

const initialState = {
  name: '',
  industry: '',
  prefecture: '',
  salary: '',
  advance_search: false,
};

class CompaniesAdvanceSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.filterInputOnRouteChanged();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.filterInputOnRouteChanged();
    }
  }

  filterInputOnRouteChanged = () => {
    if (!this.props.location) return;

    const { search } = this.props.location;
    const params = qs.parse(search);
    if (params.industry || params.prefecture || params.salary) {
      this.setState({ advance_search: true });
    }
    if (params.name) this.setState({ name: params.name });
    if (params.prefecture) this.setState({ prefecture: params.prefecture });
    if (params.industry) this.setState({ industry: params.industry });
    if (params.salary) this.setState({ salary: params.salary });
  };

  toggleBox = () => {
    this.setState({
      advance_search: !this.state.advance_search,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleSubmit = (e) => {
    // reset advance search
    this.setState({
      industry: '',
      prefecture: '',
      salary: '',
      advance_search: false,
    });
    const { name } = this.state;
    const searchString = qs.stringify({ name });

    navigate(`/companies${searchString ? `?${searchString}` : ''}`);
    e.preventDefault();
  };

  handleSubmitAdvanced = (e) => {
    // reset name search
    this.setState({ name: '' });

    const { industry, prefecture, salary } = this.state;
    const searchString = qs.stringify({ industry, prefecture, salary });

    navigate(`/companies${searchString ? `?${searchString}` : ''}`);
    e.preventDefault();
  };

  render() {
    return (
      <div id="advance-search" className="row mx-0 home-benefits home-search">
        <span className="home-search-anchor" />
        <div className="col-12 home-benefits-header px-0">
          気になる企業の働き方をチェック！
        </div>
        <div className="col-12 home-benefits-content home-search-content">
          {/* 企業検索 */}
          <div className="row mx-0 search-company-wrap">
            <div className="search-company-title">
              <span className="search-company-title-icon">
                <img src={searchIcon} alt="search" width={18} />
              </span>
              企業名で探す
            </div>
            <form className="col-12 mx-0 px-0" onSubmit={this.handleSubmit}>
              {/* 会社名 */}
              <div className="row col-12 px-0 mx-0">
                <div className="search-company-text pl-0 ml-0 col-lg-9 col-12">
                  <input
                    type="text"
                    id="search-company-name"
                    className=""
                    name="name"
                    placeholder="気になる企業名を入力しましょう"
                    value={this.state.name}
                    onChange={this.handleChange}
                  />
                </div>
                <div className="search-company-button px-0 mx-0 col-lg-3 col-12 text-center">
                  <button
                    className="btn"
                    type="button"
                    onClick={this.handleSubmit}>
                    検索する
                  </button>
                </div>
                <div
                  className={`search-company-button-more ${
                    this.state.advance_search ? 'is-hidden' : ''
                  }`}
                  onClick={this.toggleBox}>
                  ＋ 条件を追加する
                </div>
              </div>
            </form>
          </div>
          {/* 企業検索 */}
          <div
            className={`row mx-0 search-company-wrap ${
              this.state.advance_search ? '' : 'is-hidden'
            }`}>
            <div className="search-company-title">
              <span className="search-company-title-icon">
                <img src={searchIcon} alt="search" width={18} />
              </span>
              条件で探す
            </div>
            <form className="col-12 mx-0 px-0">
              <div className="search-company-row row col-12 mx-0 px-0">
                {/* エリア */}
                <div className="col-4 pl-0">
                  <label className="select-label">業種</label>
                  <div className="search-company-select">
                    <select
                      onChange={this.handleChange}
                      name="industry"
                      value={this.state.industry}
                      className="form-control select-form">
                      <option value="">すべて</option>
                      {Industries.map((ins) => (
                        <option key={ins.slug} value={ins.name}>
                          {ins.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* エリア */}
                <div className="col-4 pl-0">
                  <label className="select-label">エリア</label>
                  <div className="search-company-select">
                    <select
                      onChange={this.handleChange}
                      name="prefecture"
                      value={this.state.prefecture}
                      className="form-control select-form">
                      <option value="">すべて</option>
                      {Prefectures.map((pref) => (
                        <option key={pref.slug} value={pref.name}>
                          {pref.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {/* 社員数 */}
                <div className="col-4 pl-0 pr-0">
                  <label className="select-label">年収</label>
                  <div className="search-company-select">
                    <select
                      onChange={this.handleChange}
                      name="salary"
                      value={this.state.salary}
                      className="form-control select-form">
                      <option value="">すべて</option>
                      {Salary.map((sal) => (
                        <option key={sal.value} value={sal.value}>
                          {sal.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              {/* <div className="col-12 mx-0 px-0">
                <div className="search-company-row row col-12 mx-0 px-0">
                  <div className="col-12 pl-0">
                    <label className="select-label">福利厚生・制度</label>
                    <div className="search-company-check">
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />時短勤務
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />フレックス
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />看護休暇
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />残業削減
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />リモートワーク
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />時差Biz
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />企業内保育所
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />バリアフリー
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />生理休暇
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />不妊治療休暇
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />産前・産後休業
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />育児休暇
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />育児休業
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />男性の育休
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />育児支援金
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />ベビーシッター補助
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />保育施設補助
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="search-company-row row col-12 mx-0 px-0">
                  <div className="col-12 pl-0">
                    <label className="select-label">企業データ</label>
                    <div className="search-company-check">
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性管理職比率
                          30%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性役員がいる
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />平均残業時間
                          45時間/月 以内
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />平均残業時間
                          20時間未満
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />残業時間ゼロ
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />有給取得率
                          100%
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />有給取得率
                          80%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />育休取得率
                          100%
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />男性の育休実績あり
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性の平均勤続年数10年以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（正社員）75%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（正社員）50%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（正社員）30%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（契約社員）75%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（契約社員）50%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（契約社員）30%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（パート・アルバイト）75%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（パート・アルバイト）50%以上
                        </label>
                      </div>
                      <div className="search-company-check-input">
                        <label>
                          <input type="checkbox" name="" value="1" />女性比率（パート・アルバイト）30%以上
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="search-company-button search-company-button-bottom justify-content-center align-items-center row">
                <button
                  className="btn"
                  type="button"
                  onClick={this.handleSubmitAdvanced}>
                  この条件で検索する
                </button>
                <div
                  className="search-company-button-more"
                  onClick={this.toggleBox}>
                  ＋ 閉じる
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default CompaniesAdvanceSearch;
